var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.isCore)?_c('UiLabel',{staticClass:"ml-1"},[_vm._v("Core")]):_vm._e(),(_vm.isVerified)?_c('Icon',{staticClass:"ml-1",attrs:{"name":"check","title":"Verified"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }